import React from "react"
import Layout from "../components/Layout/layout"
import Home from "../components/Home/home"
import SEO from "../components/seo"


const IndexPage = () => (
    <Layout>
      <SEO title="Home" keywords={[`toxic`, `housing`, `stop`, `activism`, `environment`]} />
      <Home />
    </Layout>
)

export default IndexPage
